import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaUser, FaChevronDown, FaSignOutAlt, FaBars } from 'react-icons/fa';
import './Header.css';

const Header = ({ userName = 'Agent/Broker' }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('definiteagent');
    localStorage.removeItem('definiteRemember');
    navigate('/login');
  };

  const toggleSidebar = () => {
    document.body.classList.toggle('sidebar-open');
  };

  return (
    <header className="header">
      {/* Left side */}
      <div className="header-left">
        <button className="header-hamburger" onClick={toggleSidebar} aria-label="Toggle menu">
          <FaBars />
        </button>
        <img src="/definitelogo.png" alt="Definite Assurance" className="header-logo" />
        <span className="header-title">{userName}</span>
      </div>

      {/* Right side */}
      <div className="header-right">
        <a href="/double-insurance" className="header-link header-link-desktop">
          Check Double Insurance
        </a>
        <a href="/self-service" className="header-link header-link-desktop">
         Certificate Not Generated
        </a>

        <button className="header-icon-btn" title="Notifications">
          <FaBell />
        </button>

        <div className="header-user" ref={dropdownRef}>
          <div
            className="header-user-avatar"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <FaUser />
          </div>
          <span
            className="header-user-name"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            {userName}
          </span>
          <FaChevronDown
            className="header-user-dropdown-icon"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          />

          {dropdownOpen && (
            <div className="header-dropdown">
              <button onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
